"use strict";
/*
 * Created on 12. 2. 2019
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var PriceChangeReportRequest_1 = require("../model/PriceChangeReportRequest");

var PriceChangeReportRequestConverter_1 = require("./PriceChangeReportRequestConverter");
/**
 * @author SKu
 */


var PriceChangeReportRequestConverterImpl =
/*#__PURE__*/
function (_PriceChangeReportReq) {
  _inherits(PriceChangeReportRequestConverterImpl, _PriceChangeReportReq);

  function PriceChangeReportRequestConverterImpl() {
    _classCallCheck(this, PriceChangeReportRequestConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(PriceChangeReportRequestConverterImpl).call(this));
  }
  /**
   * @inheritDoc
   */


  _createClass(PriceChangeReportRequestConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new PriceChangeReportRequest_1.PriceChangeReportRequest(PriceChangeReportRequest_1.PriceChangeReportRequest.schema.dateFrom.valueOf(conversions.toDate(source.dateFrom)), PriceChangeReportRequest_1.PriceChangeReportRequest.schema.dateTo.valueOf(conversions.toDate(source.dateTo)), PriceChangeReportRequest_1.PriceChangeReportRequest.schema.categoryId.valueOf(source.categoryId), PriceChangeReportRequest_1.PriceChangeReportRequest.schema.productIds.valueOf(conversions.asObjectList(source, 'productIds', function (doc) {
        return doc;
      })));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var result = {
        dateFrom: conversions.fromDate(source.dateFrom),
        dateTo: conversions.fromDate(source.dateTo),
        categoryId: source.categoryId,
        productIds: conversions.asObjectArray(source, 'productIds', function (productId) {
          return productId;
        })
      };
      return result;
    }
  }]);

  return PriceChangeReportRequestConverterImpl;
}(PriceChangeReportRequestConverter_1.PriceChangeReportRequestConverter);

exports.PriceChangeReportRequestConverterImpl = PriceChangeReportRequestConverterImpl;